'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _date_formatter = require('../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _ramda = require('ramda');

var _collection_utility = require('../../../packages/common-utilities/src/collection_utility');

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var SummaryHeaderCreditRatings = function (_React$Component) {
  _inherits(SummaryHeaderCreditRatings, _React$Component);

  function SummaryHeaderCreditRatings(props) {
    _classCallCheck(this, SummaryHeaderCreditRatings);

    var _this = _possibleConstructorReturn(this, (SummaryHeaderCreditRatings.__proto__ || Object.getPrototypeOf(SummaryHeaderCreditRatings)).call(this, props));

    _this.renderFundRatings = _this.renderFundRatings.bind(_this);

    return _this;
  }

  _createClass(SummaryHeaderCreditRatings, [{
    key: 'renderFundRatings',
    value: function renderFundRatings() {
      var _this2 = this;

      if ((0, _ramda.isNil)(this.props.fundIndustryCreditRatings)) {
        return null;
      }
      return mapIndexed(function (fundIndustryCreditRating, index) {
        var sectionStyle = index === 2 ? 'display-inline-block padding-horizontal-0' : 'display-inline-block margin-right-40 margin-bottom-20 padding-horizontal-0';
        if (_this2.props.breakpoint < 4) {
          if (index === 2) {
            sectionStyle = 'col-xs-12 col-sm-12 col-md-12 margin-bottom-20 padding-horizontal-0';
          } else {
            sectionStyle = 'col-xs-6 col-sm-6 col-md-6 display-inline-block padding-horizontal-0';
          }
        }
        if (_collection_utility.CollectionUtility.includes(_this2.props.visibleDataPoints, 'ENABLE_SUMMARY_HEADER_INDUSTRY_RATINGS_WRAPPING') && index !== 2) {
          if (_this2.props.breakpoint < 4) {
            sectionStyle = 'col-xs-12 col-sm-12 col-md-12 padding-horizontal-0';
          } else {
            sectionStyle = 'col-xs-6 col-sm-6 col-md-6 display-inline-block padding-left-0 padding-right-40 margin-bottom-20';
          }
        }
        return _react2.default.createElement(
          'div',
          { key: index, 'data-testid': 'summary-header-ratings',
            className: 'text-top print-hide ' + sectionStyle + ' ' + (0, _functional_utility.ifMobileBreakpoint)(_this2.props.breakpoint, "margin-top-30", "margin-top-10") },
          _react2.default.createElement(
            'div',
            { className: 'tag font-regular',
              'data-testid': 'summary-header-ratings-title' },
            _string_utility2.default.renderFormattedLabel(fundIndustryCreditRating.creditRatingName, 'pdp-summmary-header-' + fundIndustryCreditRating.creditRatingSchemeCode.toLowerCase())
          ),
          _react2.default.createElement(
            'span',
            { className: 'caption font-light', 'data-testid': 'summary-header-ratings-value' },
            fundIndustryCreditRating.creditRatingCode
          ),
          _react2.default.createElement(
            'div',
            { className: 'font-light disclaimer margin-top-5',
              'data-testid': 'summary-header-ratings-date' },
            _date_formatter2.default.getEffectiveDateHeader('fund-rating-date-' + index, fundIndustryCreditRating.fundIndustryRatingDate, _this2.props.country, _this2.props.role, _this2.props.breakpoint, "")
          )
        );
      }, this.props.fundIndustryCreditRatings);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'margin-all-0' },
        this.renderFundRatings()
      );
    }
  }]);

  return SummaryHeaderCreditRatings;
}(_react2.default.Component);

exports.default = SummaryHeaderCreditRatings;